import { Directive } from "vue";

export const vLoad: Directive = {
    mounted: (el: HTMLInputElement, binding) => {
        binding.value.call();
    },
};
